import { useSearchParams, useNavigate } from "react-router-dom";
import Card from "../components/Card";
import Button from "../components/Button";
import { useTheme } from "../hooks/useTheme";

export default function PaymentFail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { theme } = useTheme();

  const statusCode = searchParams.get("status_code") || "—";
  const reason = searchParams.get("reason") || "خطای ناشناخته";

  return (
    <div data-theme={theme} className="min-h-screen bg-surface-base flex items-center justify-center p-4">
      <Card className="max-w-md w-full text-center">
        {/* Error Icon */}
        <div className="w-16 h-16 rounded-full bg-status-error bg-opacity-20 flex items-center justify-center mx-auto mb-5">
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-status-error-text"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-h1 text-text-main mb-2">پرداخت ناموفق</h1>
        <p className="text-body text-text-secondary mb-6">
          متأسفانه پرداخت شما با خطا مواجه شد
        </p>

        {/* Details */}
        <div className="bg-surface-hover rounded-btn p-4 mb-6 text-right space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-small text-text-tertiary">کد وضعیت</span>
            <span className="text-body font-number text-text-main font-medium" dir="ltr">
              {statusCode}
            </span>
          </div>
          <div className="border-t border-line" />
          <div className="flex items-start justify-between gap-4">
            <span className="text-small text-text-tertiary whitespace-nowrap">علت خطا</span>
            <span className="text-body text-text-secondary text-left">
              {reason}
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <Button
            className="w-full !py-3"
            onClick={() => navigate("/wallet")}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="1 4 1 10 7 10" />
              <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
            </svg>
            تلاش مجدد
          </Button>
          <button
            onClick={() => navigate("/dashboard")}
            className="w-full py-3 rounded-btn border border-line text-body text-text-secondary hover:bg-surface-hover transition-all"
          >
            بازگشت به داشبورد
          </button>
        </div>

        <p className="text-small text-text-tertiary mt-6">
          اگر مشکل ادامه داشت، با پشتیبانی تماس بگیرید
        </p>
      </Card>
    </div>
  );
}